import { AccountTree } from '@mui/icons-material';
import { Chip, ListItemText } from '@mui/material';

export function CoordinateChip({ value }: { value?: string }): React.JSX.Element {
  if (value === '' || value === undefined) {
    return <></>;
  }

  return <Chip size={'small'} label={value} icon={<AccountTree fontSize={'small'} />} />;
}

export default function CoordinateListItem({
  label,
  coordinate,
}: {
  label: string;
  coordinate?: string;
}): React.JSX.Element {
  return <ListItemText primary={label} secondary={<CoordinateChip value={coordinate} />} />;
}
